import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";
import { throwError } from "../errors.js";

export default class Poll {
    // takes the Vuex context.
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;

        //this.pollStatus = '';
        this.pullResData = {}
    }

    pollInsuranceInfo(data) {

        const puid = 'pg_collect_insurance_info';
        const $ps = this;
        const $fs = new Funnel({ ctx: this.ctx, router: this.router });

        $fs.startPageLoading(puid);

        const reqType = $fs.getReqType(puid);
        console.log('pollInsuranceInfo', reqType);

        $ps.poll(data, function (result) {
            if (result.req_status == 'complete') {
                const res = $ps.pullResData;
                console.log('Merged data: ', res);

                if (res.data && Object.keys(res.data).length > 0) {
                    $fs.ajaxVuexResponseHandler(data, res);
                }
                $fs.completePageLoading();

            } else {
                const vxnTpl = result.req_status == 'error' ? 'dp_no_data_tpl' : 'dp_blanks_tpl';
                $fs.resetNotification(`vx_notify_warning_${vxnTpl}`);

                $ps.ctx.commit('UPDATE_PAGES_SEQ', $ps.ctx.getters.factory.fxp_pages_sequence);
                const nxtPuid = $fs.getNextPUID(puid);

                $ps.ctx.commit('DELETE_PAGE_SEQ', [puid]);
                $fs.buildRoutesFromPgSeq();

                $fs.disablePublicRecordsLookupPermission();

                $ps.router.push($ps.ctx.getters.funnel.elements[nxtPuid].page_route).catch(() => { });
                $fs.completePageLoading();

                if (result.req_status == 'pending')
                    throwError(new Error('Polling did not return data.'), { "payload": JSON.stringify(data), "page": puid });
            }
        });
    }

    poll(data, callback) {
        const $ps = this;
        const $fs = new Funnel({ ctx: this.ctx });
        const reqType = $fs.getReqType('pg_collect_insurance_info');
        var c = 0,
            endpoint = `/api?req=${reqType}&action=pull-insu-info`,
            // countLimit = 26,
            reqStatus = '',
            // timeoutThreshold = 2000,
            stopTime = Date.now() + (60 * 1000), // 60 second timeout
            error = false, // track http errors
            lastRequest = 0;

        console.log("Starting polling: " + new Date());

        async.doUntil(
            function (cb) {
                c++;
                lastRequest = Date.now()
                var errorCount = 0
                console.log(`This pull attempt: ${c}`);
                $.ajax({
                    type: 'POST',
                    url: `${endpoint}`,
                    data: data,
                    timeout: (30 * 1000),
                    success: function (res) {
                        console.log(`poll result for attempt: ${c}`, res.insuInfoPullRes);

                        if (!res.insuInfoPullRes) {
                            console.log("Poll result not found. Aborting.");
                            error = true;
                            return;
                        }

                        reqStatus = res.insuInfoPullRes.request_status;
                        $ps.pullResData = res;
                    },
                    error: function () {
                        // bail if we get an error
                        error = true;
                        /*
                        errorCount++

                        if (errorCount <= 3) {
                            setTimeout(function () {
                                //context.dispatch('getFunnel');
                            }, 3000)
                        }
                        else {
                            // Do something here
                        }
                        */
                    },
                    complete: function (res, status) {
                        let responseDiff = Date.now() - lastRequest
                        let timeout = 0;

                        /*
                        console.log('responseDiff', responseDiff)

                        if (responseDiff <= timeoutThreshold) {
                            timeout = timeoutThreshold - responseDiff
                        }
                        console.log('timeout', timeout)
                        */

                        setTimeout(cb, timeout);
                    }
                });
                //setTimeout(cb, 3055);
            },
            function () {
                const breakStatuses = ['complete', 'error', 'failed'];
                // return (breakStatuses.indexOf(reqStatus) != -1 || c > countLimit);
                var endPolling = (error || breakStatuses.indexOf(reqStatus) != -1 || Date.now() >= stopTime);
                if (endPolling) {
                    console.log("End polling: " + new Date());
                }

                return endPolling;
            },
            function (err) {
                reqStatus = reqStatus == '' ? 'error' : reqStatus;
                const pollStatus = { req_status: reqStatus };

                callback(pollStatus);
            }
        );
    }

}
